import {useEffect, useState } from "react";

import { DataTable, DataTableCellSelection } from "primereact/datatable";
import { Column } from "primereact/column";
import { KeyValue,Status} from "../../ProviderProfile/models";
import httpService from "../../../../services/httpService";
import { ApiEndpoints, Constants } from "../../../../constants/appConstants";
import "./sco-dashboard.styles.scss"
import { useAppContext } from "../../../../Context";
import { useAuthContext } from "../../../../Context/AuthContext";



export interface ScoKpiDashboardComponent {
  searchHandler: (query: any,columns: any,exactMatch: boolean) => void;
}

export const ScoKpiDashboardComponent = ({
  searchHandler,
}: ScoKpiDashboardComponent) => {
  const [providersPerformanceData, setProvidersPerformanceData] = useState<
    Record<string, string>[]
  >([]);
  
  const [selectedCell, setSelectedCell] = useState<DataTableCellSelection<
    KeyValue[]
  > | null>(null);
  
 const { isAdministrator } = useAuthContext();
  const [tiers, setAllTiers] = useState<any[]>([]);
  const [statuses, setAllStatues] = useState<any[]>([]);

const { reviewYear } = useAppContext();
  useEffect(() => {
    if (reviewYear) {
      getScoKpiDashboardData();
      getAllTiers();
      getAllStatuses();
    }
  }, [reviewYear]);

  const getAllTiers = () => {
    httpService.get<any[]>(`${ApiEndpoints.GetTiers}?providerType=${Constants.SCOKey}`).then((response) => {
      setAllTiers(response.data);
    }).catch((error) => {
      console.error('Error fetching tiers:', error);
    });
  }

  const getAllStatuses = () => {
    httpService.get<Status[]>(`${ApiEndpoints.GetStatus}?providerType=${Constants.SCOKey}`).then((response) => {
      setAllStatues(response.data);
    }).catch((error) => {
      console.error('Error fetching tiers:', error);
    });
  }

  const getScoKpiDashboardData = () => {
    httpService.get<any[]>(`${ApiEndpoints.getPfpScoKpiDashboardData}/${reviewYear}`).then((response) => {
      setProvidersPerformanceData(response.data);
    }).catch((error) => {
      console.error('Error fetching tiers:', error);
    });
  }
  const handleCellSelection = (e: any) => {

    //if the login user admin then filter the data based on the selected cell
    //if the login user is not admin then return
    if(!isAdministrator()){
      return;
    }


    if (
      e.value !== null &&
      e.value.column.props.header !== "Provider Review Status" &&
      e.value.column.props.header !== "Total" && e.value.column.props.header !== "PBC Type" &&
      e.value.column.props.header !== "Unsubmitted" 
    ) {
      setSelectedCell(e.value);
      let filterBy=getFilterTypeByValue(e.value.column.props.header);
      //['currentTier']
      //['reviewStatus']
      searchHandler(e.value.column.props.header, [filterBy],true);
    } else if (e.value === null || e.value.column.props.header === "Total") {
      setSelectedCell(null);
      searchHandler("", ['reviewStatus'],true);
    }
  };

const getFilterTypeByValue = (value: string) => {
  if(tiers && tiers.length > 0) {
    const tier = tiers.find((tier: any) => tier.tierName === value);
    if (tier) {
      return 'currentTier';
    }
  }
  if(statuses && statuses.length > 0) {
    const status = statuses.find((status: any) => status.statusName === value);
    if (status) {
      return 'reviewStatus';
    }
  }
  return '';
}

  return (
    providersPerformanceData && providersPerformanceData.length > 0 && (
      <div className="kpi-table-container">
        <DataTable
          value={providersPerformanceData}
          cellSelection={isAdministrator()}
          selectionMode={isAdministrator() ? "single" : undefined}
        selection={selectedCell}
       onSelectionChange={(e: any) => handleCellSelection(e)}
        size="small"
        className="kpi-table"
      >
        { Object.keys(providersPerformanceData[0]).map((key: any) =>
          <Column
            key={key}
            field={key}
            header={key}
            headerClassName="kpi-table-header"
            bodyClassName="column-align-center"
          ></Column>
        )}

      </DataTable>
    </div>
    )
  );

};


